export default "__VITE_PUBLIC_ASSET__1c07a2a7__"